import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { API_IP } from "../configFiles/apiConfig"; // apiConfig.js dosyasından IP ve port bilgilerini al
import { PickList } from "primereact/picklist";
import { Message } from "primereact/message";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import yerlembg from "../images/yerlemicon.svg";

export default function EditMutlipleTransportationSchema() {
  const toast = useRef(null);
  const [port, setPort] = useState(null);
  const navigate = useNavigate();

  const showSuccess = () => {
    toast.current.show({
      severity: "success",
      summary: "Başarılı",
      detail: "Servis aktarma işlemleri başarılı.",
      life: 3000,
    });
  };

  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: "Hata",
      detail: "Servis aktarma işlemi hatalı",
      life: 3000,
    });
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get("school-code");
    setPort(code);
    console.log("Port", code);
    const fetchData = async () => {
      try {
        const response = await fetch(
          `http://${API_IP}:${code}/mobile/transportationSchema/findAllTransportationSchemas`
        );
        const jsonData = await response.json();
        setRoute(jsonData);
      } catch (error) {
        console.error("Rota verisi çekme hatası:", error);
      }
    };
    fetchData();
  }, []);

  const [route, setRoute] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [selectedSource, setSelectedSource] = useState(null);
  const [sourceList, setSourceList] = useState([]);
  const [targetList, setTargetList] = useState([]);
  const [firstPickListEnable, setFirstPickListEnable] = useState(false);
  const [secondPickListEnable, setSecondPickListEnable] = useState(false);
  const [targetTransportationSchemaId, setTargetTransportationSchemaId] =
    useState(null);
  const [sourceTransportationSchemaId, setSourceTransportationSchemaId] =
    useState(null);
  const [isMdScreen, setIsMdScreen] = useState(false);

  const handleResize = () => {
    // Ekran boyutunu kontrol et ve md ekran mı değil mi belirle
    setIsMdScreen(window.innerWidth >= 960); // Bu değeri kendi ihtiyacınıza göre ayarlayabilirsiniz
  };

  useEffect(() => {
    // Başlangıçta ekran boyutunu kontrol et
    handleResize();

    // Ekran boyutu değişikliklerini dinle
    window.addEventListener('resize', handleResize);

    // Temizleme işlemi
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const filteredOptions = route.filter((item) => item.title !== selectedSource);
  const filteredSourceOptions = route.filter(
    (item) => item.title !== selectedRoute
  );

  const handleAutocompleteChange = (event, value) => {
    setSelectedSource(value);
    setFirstPickListEnable(true);
    setSecondPickListEnable(false);

    const TransportationSchema = route.find((item) => item.title === value);

    const selectedRoute = route.find((item) => item.title === value);
    setSourceTransportationSchemaId(TransportationSchema.id);
    if (selectedRoute.id === TransportationSchema.id) {
      setSourceList(selectedRoute.relations);
    } else {
    }
  };

  // Autocomplete seçim değiştiğinde çalışan fonksiyon
  const handleTransferredAutocompleteChange = (event, value) => {
    setSelectedRoute(value);
    setSecondPickListEnable(true);

    const TransportationSchema = route.find((item) => item.title === value);

    const selectedRoute = route.find((item) => item.title === value);
    setTargetTransportationSchemaId(TransportationSchema.id);
    if (selectedRoute.id === TransportationSchema.id) {
      setTargetList(selectedRoute.relations);
    } else {
    }
  };

  const MyPickList = () => {
    const pickListStyle = `
    .p-picklist-buttons .p-button {
      background-color: #007bff; /* Mavi renk kodu */
      color: #fff; /* Beyaz renk kodu */
      border-color: transparent; /* Kenarlık rengini transparan yapar */
    }

    .p-picklist-buttons .p-button:not(:first-child) {
    }
    .p-picklist-list-wrapper .p-picklist-header {
      flex: 1 1 100%; /* Esneklik değerlerini ayarlar */
      background-color: rgba(0, 123, 255); /* Mavi renk kodu (%50 transparan) */
      color: #fff; /* Beyaz renk kodu */
      font-weight: 400; /* Yazı kalınlığını ayarlar */
      justify-content: center; /* İçeriği yatayda ortalar */ }
  `;
    return (
      <>
        <style>{pickListStyle}</style>
        <PickList
          source={sourceList}
          target={targetList}
          sourceFilterPlaceholder="Aramak İstediğiniz İsmi Giriniz"
          targetFilterPlaceholder="Aramak İstediğiniz İsmi Giriniz"
          filter
          filterBy="student.name"
          sourceHeader="Bulunduğu Servis"
          targetHeader="Aktarılacak Servis"
          onChange={(e) => {
            setSourceList(e.source);
            setTargetList(e.target);
          }}
          itemTemplate={(item) => (
            <div key={item.id}>
              {item.student.name} {item.student.surname}
            </div>
          )}
          sourceStyle={{ height: "30rem" }}
          targetStyle={{ height: "30rem" }}
          className="button-color-blue"
        />
      </>
    );
  };

  const HandleBackButton = () => {
    navigate(-1);
  };
  const HandlePushList = async (e) => {
    try {
      const response = await fetch(
        `http://${API_IP}:${port}/mobile/transportationSchema/updateStudents/?sourceTransportationSchemaId=${sourceTransportationSchemaId}&targetTransportationSchemaId=${targetTransportationSchemaId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(targetList),
        }
      );

      if (response.ok) {
        try {
          const response = await fetch(
            `http://${API_IP}:${port}/mobile/transportationSchema/updateStudents/?sourceTransportationSchemaId=${targetTransportationSchemaId}&targetTransportationSchemaId=${sourceTransportationSchemaId}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(sourceList),
            }
          );

          if (response.ok) {
            showSuccess();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        } catch (error) {
          console.error("Post işlemi sırasında hata oluştu:", error);

          showError();

          // Hata durumunda yapılacak işlemleri buraya ekleyebilirsiniz.
        }
      }
    } catch (error) {
      console.error("Post işlemi sırasında hata oluştu:", error);
      showError();
    }
  };

  return (
    <div className="h-full lg:h-screen flex md:justify-center">
      <img src={yerlembg} className="absolute h-full object-cover z-0 " />
      <div className="flex lg:p-2 p-20 flex-col h-full w-full justify-around ">
        <Button
          icon="pi pi-chevron-left"
          className={isMdScreen ? "absolute top-4 left-4" : "hidden"}
          onClick={HandleBackButton}
          rounded
          outlined
          severity="info"
          aria-label="User"
        />
        <Toast ref={toast} />
        <div className="flex lg:flex-row lg:justify-around flex-col  mt-4 ">
          <Autocomplete
            disablePortal
            options={filteredSourceOptions.map((item) => item.title)}
            id="combo-box1"
            className="lg:w-[20%] w-full lg:py-0 py-2"
              renderInput={(params) => (
              <TextField {...params} label="Güzergah Seçiniz" />
            )}
            onChange={handleAutocompleteChange}
          />
          {!firstPickListEnable && !secondPickListEnable ? (
            <Message
              severity="warn"
              className="lg:py-0 py-2"
              text="Lütfen aktarma yapılacak işlemi servisleri Seçiniz"
            />
          ) : firstPickListEnable && !secondPickListEnable ? (
            <Message
              severity="warn"
              className="lg:py-0 py-2"

              text="Lütfen Aktarılacak Servisi Seçiniz"
            />
          ) : !firstPickListEnable && secondPickListEnable ? (
            <Message severity="warn"
            className="lg:py-0 py-2"
            text="Lütfen Bulunduğu Servisi Seçiniz" />
          ) : null}
          <Autocomplete
            disablePortal
            options={filteredOptions.map((item) => item.title)} // Filtrelenmiş seçenekleri kullan
            id="combo-box2"
            className="lg:w-[20%] w-full lg:py-0 py-2"

            renderInput={(params) => (
              <TextField {...params} label="Güzergah Seçiniz" />
            )}
            onChange={handleTransferredAutocompleteChange} // Seçim değiştiğinde handleTransferredAutocompleteChange fonksiyonunu çağır
          />
        </div>
        <div
          id="route-picklist"
          className={`my-2 ${
            firstPickListEnable && secondPickListEnable
              ? ""
              : "pointer-events-none"
          }`}
        >
          <MyPickList />
        </div>
        <div className="flex flex-row justify-center ">
          <Button
            className="w-[70%]"
            
            severity="info"
            label="Aktarma İşlemini Tamamla"
            icon="pi pi-save"
            iconPos="right"
            onClick={HandlePushList}
          />
        </div>
      </div>
    </div>
  );
}
